module.exports = __webpack_public_path__ + "static/img/22.c0c497c2.png";